import { combineReducers } from 'redux';
import { Executorship } from '../modules/Executorship/indexReducer';
import { Common } from '../common/redux/reducers';
import { Interface } from '../common/redux/reducers/interface';
import { Employees } from '../modules/Employees/indexReducer';
import { Transport } from '../modules/Transport/indexReducer';
import { Documents } from '../modules/Document/indexReducer';
import { Authorization } from '../modules/Authorization/redux/reducers';
import { Customers } from '../modules/Customers/redux/reducers';
import { SystemSettings } from '../modules/SystemSettings/indexReducer';
import { Templates } from '../modules/Templates/indexReducer';
import { Executors } from '../modules/Executors/indexReducer';
import listsReducers from '../modules/Lists/redux/reducers';

export default combineReducers({
  Common,
  Interface,
  Executorship,
  Employees,
  Customers,
  Transport,
  Documents,
  Authorization,
  SystemSettings,
  Templates,
  Executors,
  Lists: listsReducers
});
